import { useEffect, useRef } from 'react';
export const useDidUpdate = (callback, deps) => {
    const rendered = useRef(false);
    useEffect(() => {
        if (!rendered.current) {
            rendered.current = true;
        }
        else {
            return callback();
        }
    }, deps);
};
//# sourceMappingURL=use-did-update.js.map